import React from 'react';
import { Tag } from './TagTheyAreIt.styles';
import { CloudImage } from '@components/CloudImage';
import { MagneticAvatar } from './MagneticAvatar';

interface MagenticProps {
  avatarUrl: string;
  sizeVariant?: number;
  top: string;
  left: string;
  type: string;
  alt?: string;
  resTop: string;
  resLeft: string;
  resSizeVariant?: number;
}

export const MagneticItem: React.FC<MagenticProps> = ({
  avatarUrl,
  sizeVariant,
  top,
  left,
  resTop,
  resLeft,
  resSizeVariant,
  type,
  alt = 'Guestlist Tag',
}) => {
  const values = { x: 0, y: 0, percent: 0, shouldMove: false };
  if (type === 'avatar') {
    return (
      <MagneticAvatar
        avatarUrl={avatarUrl}
        sizeVariant={sizeVariant}
        top={top}
        left={left}
        resTop={resTop}
        resLeft={resLeft}
        resSizeVariant={resSizeVariant}
      />
    );
  } else {
    return (
      <Tag
        resTop={resTop}
        resLeft={resLeft}
        top={top}
        left={left}
        values={values}
        sizeVariant={`${sizeVariant}px`}
        resSizeVariant={`${resSizeVariant}px`}
      >
        <CloudImage src={avatarUrl} alt={alt} />
      </Tag>
    );
  }
};
